export default __webpack_public_path__ + "static/media/advantageIcon1.1d729182.png";